module.exports = __webpack_public_path__ + "img/zm.53783063.svg";